
import { mapState, mapGetters } from 'vuex'
import baseLogic from '~/mixins/base-logic'

export default {
    mixins: [baseLogic],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            steppers: 1,
            selectedBank: 1,
            remainingTime: {
                minutes: 14,
                seconds: 5,
            },
            pModel: 0,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
            cms: (state) => state.cms.cms,
        }),
        ...mapGetters({
            depositInstruction: 'cms/depositInstruction',
            loading: 'themes/company-bank/loading',
            companyBankAccounts: 'themes/company-bank/companyBankAccount',
            playerPrimaryBankAccount: 'themes/player-bank/primaryBankAccount',
        }),
    },
    async mounted() {
        const params = { currency: this.$cookie.get('player')?.currency }
        await this.$store.dispatch(
            'themes/company-bank/getCompanyBankPlayerAccount',
            params
        )
        // Call this store action only when /player/deposits and mobile device
        const filterDepositInstructionContent = this.cms.filter(
            (el) => el.component_code === 'DepositInstructionContent'
        )
        if (
            this.$route.path === '/player/deposits' &&
            filterDepositInstructionContent?.length <= 0
        )
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: 2,
                component_code: 'DepositInstructionContent',
            })
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        copiedBankId(item) {
            try {
                setTimeout(() => {
                    this.copyAndOpenApp(item?.bank_account_number)
                }, 300)
                const playerBankAccountNumber = document.getElementById(
                    'playerBankAccountNumber'
                )
                navigator.clipboard.writeText(playerBankAccountNumber.innerText)
            } catch (error) {}
        },
    },
}
